(function () {
  'use strict';

  /**
   * Format cents as a money string using the shop's money format.
   * Falls back to a simple USD formatter if window.theme.moneyFormat is unavailable.
   */
  function formatMoney(cents) {
    var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(cents / 100));
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimalsWithCommas = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return moneyFormat
      .replace('{{amount}}', withCommas)
      .replace('{{amount_no_decimals}}', noDecimalsWithCommas)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals);
  }

  /**
   * On variant change, update all unit-price containers that carry a
   * data-days-supply-map attribute with the correct days supply and price
   * for the newly selected variant.
   */
  document.addEventListener('product:variant-change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    var containers = document.querySelectorAll(
      '[data-unit-price-container][data-days-supply-map]'
    );

    containers.forEach(function (container) {
      var mapStr = container.getAttribute('data-days-supply-map');
      if (!mapStr) return;

      var mapData;
      try {
        mapData = JSON.parse(mapStr);
      } catch (e) {
        return;
      }

      var daysSupply = mapData[String(variant.id)];

      if (daysSupply != null) {
        container.dataset.unitPriceAvailable = 'true';

        var priceEl = container.querySelector('[data-unit-price]');
        if (priceEl) {
          priceEl.innerText = formatMoney(variant.price);
        }

        var baseUnitEl = container.querySelector('[data-unit-price-base-unit]');
        if (baseUnitEl) {
          baseUnitEl.innerText = daysSupply + ' day supply';
        }
      } else {
        container.dataset.unitPriceAvailable = 'false';
      }
    });

    var badges = document.querySelectorAll('[data-days-supply-badge][data-days-supply-badge-map]');
    badges.forEach(function (badge) {
      var mapStr = badge.getAttribute('data-days-supply-badge-map');
      if (!mapStr) return;

      var mapData;
      try {
        mapData = JSON.parse(mapStr);
      } catch (e) {
        return;
      }

      var text = mapData[String(variant.id)];
      if (!text) return;

      var span = badge.querySelector('.product-blocks__product-labels-item-text');
      if (span) span.innerText = text;
    });
  });
})();
